import './index.css';
import React from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';

library.add(fab, fas);

const Socials = () => {
    React.useEffect(() => {
        console.log('Socials Mounted');
    }, []);

    return (
        <div className='Socials flex-container'>
            <div className='row'>
                <div className='col-4'>
                    <a
                        className='fab-icons'
                        href='https://www.github.com/tsuialan'>
                        <FontAwesomeIcon icon={['fab', 'github']} size='3x' />
                    </a>
                </div>
                <div className='col-4'>
                    <a
                        className='fab-icons'
                        href='https://www.linkedin.com/in/alan-tsui'>
                        <FontAwesomeIcon icon={['fab', 'linkedin']} size='3x' />
                    </a>
                </div>
                <div className='col-4'>
                    <a
                        className='fab-icons'
                        href='https://devpost.com/tsuialan'>
                        <FontAwesomeIcon icon={['fab', 'dev']} size='3x' />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Socials;
